import TextInputPage from '@app-studio-web/ui/pages/TextInputPage'

export default function NameInputPage() {
  return (
    <TextInputPage
      heading="pages.onboarding.name.title"
      placeholder="pages.onboarding.name.placeholder"
      description="pages.onboarding.name.subtitle"
      inputName="name"
      onSubmit={() => {}}
    />
  )
}
